import clsx from 'clsx';
import { FunctionComponent, PropsWithChildren } from 'react';

import styles from './FullWindowModalHeader.module.scss';

interface FullWindowModalHeaderProps extends PropsWithChildren {
    className?: string;
}

/**
 * Top slot of `FullWindowModal`. Renders as a 66px-min-height bar with a
 * white background and a bottom border — matches the legacy `OverFullWindow`
 * proportions so existing screens migrated to this component don't look
 * jarringly different. Children fill the bar; consumers decide internal
 * layout (logo, title, actions, close button…).
 *
 * Convention: this slot only provides chrome (height, padding, bg, border)
 * and a baseline `display: flex; align-items: center` so a single child
 * centres vertically by default. If you need a custom layout (e.g. grid
 * with name | tabs | close), wrap your content in an inner `<div>` with
 * your own className — don't fight the slot's `display` rule via the
 * `className` prop. CSS Modules + same-specificity overrides aren't a
 * reliable way to win the cascade across bundle orderings.
 */
export const FullWindowModalHeader: FunctionComponent<FullWindowModalHeaderProps> = ({ children, className }) => {
    return <div className={clsx(styles.header, className)}>{children}</div>;
};

export default FullWindowModalHeader;
